export default __webpack_public_path__ + "static/media/Best_Audience.c05ebb29.svg";